// react
import { useEffect, useState } from "react";

//antd
import { Card, Badge } from "antd";
import Icon from "@ant-design/icons";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showAppModal } from "~/redux/actions/app";
import TalentIcon from "~/components/app/TalentIcon";
import EleduckIcon from "~/components/app/EleduckIcon";
import RuleIcon from "~/components/app/RuleIcon";

// utils
import { setNavigationStorage, getNavigationStorage } from "~/utils/ui";
import settings from "../../settings";
import router from "next/router";

const SiderNavigationCard = (props) => {
  const [state, setState] = useState({
    rule: false,
    resume: false,
    about: false,
    talent: false,
  });

  const initNavigation = () => {
    const isRuleDot = getNavigationStorage("6GzfGe");
    const isResumeDot = getNavigationStorage("talentResume");
    const isAboutDot = getNavigationStorage("MZXfoe");
    const isTalentDot = getNavigationStorage("z1f0Kp");
    setState({
      ...state,
      rule: isRuleDot,
      resume: isResumeDot,
      about: isAboutDot,
      talent: isTalentDot,
    });
  };

  useEffect(() => {
    initNavigation();
  }, []);

  return (
    <Card className="navigation-card">
      <div className="navigation-box">
        <a
          href="https://eleduck.com/posts/6GzfGe"
          onClick={() => setNavigationStorage("6GzfGe")}
          className="navigation-item"
          target="_blank"
        >
          <Icon
            className="navigation-item-icon"
            component={RuleIcon}
            alt="社区规则"
            style={{ color: "#f9ba48", marginBottom: "4px" }}
          />
          <Badge
            className="navigation-item-badge"
            dot={state.rule}
          >
            社区规则
          </Badge>
        </a>
        <div className="navigation-line"></div>
        <a
          href="https://eleduck.com/posts/MZXfoe"
          onClick={() => setNavigationStorage("MZXfoe")}
          className="navigation-item"
          target="_blank"
        >
          <Icon
            className="navigation-item-icon"
            component={EleduckIcon}
            alt="关于电鸭"
            style={{ color: "#f9ba48", marginBottom: "4px" }}
          />
          <Badge
            className="navigation-item-badge"
            dot={state.about}
          >
            关于电鸭
          </Badge>
        </a>
        {/* <a
          href="https://eleduck.com/posts/6yGflz"
          onClick={() => setNavigationStorage("6yGflz")}
          className="navigation-item"
        >
          <img
            className="navigation-item-image"
            src={"/static/icons/construction.png"}
            alt="加入我们"
          />
          <Badge dot={state.construction}>加入我们</Badge>
        </a> */}
        <div className="navigation-line"></div>
        <a
          href="https://eleduck.com/posts/z1f0Kp"
          target="_blank"
          onClick={() => {
            setNavigationStorage("z1f0Kp");
          }}
          className="navigation-item"
        >
          <Icon
            className="navigation-item-icon"
            component={TalentIcon}
            alt="人才推荐"
            style={{ color: "#f9ba48", marginBottom: "4px" }}
          />
          <Badge
            className="navigation-item-badge"
            style={{ color: "#1b1b1b", fontWeight: "medium" }}
            dot={state.talent}
          >
            人才推荐
          </Badge>
        </a>
      </div>
      <style jsx>
        {`
          .navigation-card .ant-card-body {
            padding: 16px 22px;
          }

          .navigation-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .navigation-item {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          }

          .navigation-item-badge {
            margin-top: 4px;
          }

          .navigation-line {
            width: 0px;
            height: 32px;
            border: 1px solid #f2f2f2;
          }
        `}
      </style>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SiderNavigationCard);
